"use client";

import z from "zod";

import { stripeConnectStatusEnum } from "../../../../../lib/types/enums/community/stripeConnectStatus";
import type { UseRequestQueryProps } from "../../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../../request/hooks/useRequestQuery";
import { keyCommunitiesStripeConnectStatus } from "./keyCommunitiesStripeConnectStatus";

export const communitiesStripeConnectStatusSchema = z.object({
  status: stripeConnectStatusEnum,
});

export type UseRequestCommunitiesStripeConnectStatusProps =
  UseRequestQueryProps & {
    id: number;
  };

export const useRequestCommunitiesStripeConnectStatus = ({
  id,
  ...props
}: UseRequestCommunitiesStripeConnectStatusProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: communitiesStripeConnectStatusSchema,
      urlBackendPath: `/me/communities/${id}/stripe/status`,
    },
    queryKey: keyCommunitiesStripeConnectStatus({ id }),
  }),
});
